import { router } from '@inertiajs/react'
import { useState } from 'react'
import Avatar from './Avatar'
import Button from './Button'
import FormField from './FormField'
import Modal from './Modal'
import SignOutButton from './SignOutButton'

export default function ProfileModals({ user, basePath, isOpen, onClose }) {
  const [view, setView] = useState('profile')
  const [profileForm, setProfileForm] = useState({ name: user?.name || '' })
  const [passwordForm, setPasswordForm] = useState({ password: '', password_confirmation: '' })

  const handleClose = () => {
    setView('profile')
    onClose()
  }

  const handleProfileSubmit = (e) => {
    e.preventDefault()
    router.patch(`${basePath}/profile`, { user: profileForm }, {
      onSuccess: () => {
        setView('profile')
        onClose()
      }
    })
  }

  const handlePasswordSubmit = (e) => {
    e.preventDefault()
    router.patch(`${basePath}/password`, { user: passwordForm }, {
      onSuccess: () => {
        setView('profile')
        setPasswordForm({ password: '', password_confirmation: '' })
        onClose()
      }
    })
  }

  if (!isOpen || !user) return null

  if (view === 'editProfile') {
    return (
      <Modal onClose={handleClose} title="Edit Profile">
        <form onSubmit={handleProfileSubmit} className="space-y-4">
          <FormField
            label="Name"
            name="name"
            type="text"
            value={profileForm.name}
            onChange={(e) => setProfileForm({ name: e.target.value })}
            placeholder="Your name"
          />
          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="secondary"
              onClick={() => setView('profile')}
            >
              Cancel
            </Button>
            <Button type="submit">
              Save
            </Button>
          </div>
        </form>
      </Modal>
    )
  }

  if (view === 'changePassword') {
    return (
      <Modal onClose={handleClose} title="Change Password">
        <form onSubmit={handlePasswordSubmit} className="space-y-4">
          <FormField
            label="New Password"
            name="password"
            type="password"
            value={passwordForm.password}
            onChange={(e) => setPasswordForm(prev => ({ ...prev, password: e.target.value }))}
            required
          />
          <FormField
            label="Confirm Password"
            name="password_confirmation"
            type="password"
            value={passwordForm.password_confirmation}
            onChange={(e) => setPasswordForm(prev => ({ ...prev, password_confirmation: e.target.value }))}
            required
          />
          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="secondary"
              onClick={() => setView('profile')}
            >
              Cancel
            </Button>
            <Button type="submit">
              Update Password
            </Button>
          </div>
        </form>
      </Modal>
    )
  }

  return (
    <Modal onClose={handleClose} title="Profile">
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <Avatar initials={user.initials} size="xl" onClick={() => {}} />
          <div>
            <p className="text-lg font-medium text-gray-900">{user.name || 'No name set'}</p>
            <p className="text-sm text-gray-500">{user.email}</p>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-4 space-y-2">
          <Button
            variant="ghost"
            onClick={() => setView('editProfile')}
            className={`w-full text-left justify-start`}
          >
            Edit Profile
          </Button>
          <Button
            variant="ghost"
            onClick={() => setView('changePassword')}
            className={`w-full text-left justify-start`}

          >
            Change Password
          </Button>
          <SignOutButton />
        </div>
      </div>
    </Modal>
  )
}
